import React, { useState } from 'react';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { BruceMark } from '../Layout/Layout';
import { AuthGate } from '../ProtectedRoute';
import { C } from '../../theme';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, user, loading: authLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (authLoading) return <AuthGate />;
  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="main" sx={{
      minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: C.bg, px: 2,
      background: `radial-gradient(900px 500px at 50% -10%, ${C.accent}22, transparent 60%), ${C.bg}`,
    }}>
      <Box sx={{ width: '100%', maxWidth: 380 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <BruceMark size={40} />
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: 20, lineHeight: 1.1 }}>Bruce</Typography>
            <Typography sx={{ fontSize: 12.5, color: C.ink3 }}>trading desk</Typography>
          </Box>
        </Box>

        <Box sx={{ bgcolor: C.panel, border: `1px solid ${C.line}`, borderRadius: '14px', p: { xs: 2.5, sm: 3 } }}>
          <Typography component="h1" sx={{ fontSize: 17, fontWeight: 600, mb: 0.5 }}>Sign in</Typography>
          <Typography sx={{ fontSize: 13, color: C.ink2, mb: 2 }}>Home network only.</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField margin="dense" required fullWidth id="email" label="Email" name="email"
              autoComplete="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
            <TextField margin="dense" required fullWidth name="password" label="Password" type="password"
              id="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Button type="submit" fullWidth variant="contained" disabled={loading} sx={{ mt: 2.5, py: 1.25 }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;
